module.exports = __webpack_public_path__ + "static/media/scratch-ananas.ffb7816a.png";